import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Trailer } from '~models/trailer.model';
import { TrailerType } from '~v2Models/well.model';
import { Subcarrier } from '~models/subcarrier.model';

@Component({
  selector: 'sa-trailer-management-archived',
  templateUrl: './trailer-management-archived.component.html',
  styleUrls: ['./trailer-management-archived.component.scss'],
})
export class TrailerManagementArchivedComponent implements OnInit {
  @Input() public trailers: Observable<Trailer[]>;
  @Input() public trailerTypes: Observable<TrailerType[]>;
  @Input() public subcarriers: Observable<Subcarrier[]>;
  @Input() public canManageTrailerManagement: BehaviorSubject<boolean>;
  public createEdit$$ = new BehaviorSubject<Trailer | {}>(null);
  public sortKey = 'trailerName';
  public sortOrder: 'asc' | 'desc' = 'asc';
  public sortedArchivedTrailers: Trailer[] = [];
  public sortIcons: { [key: string]: string } = {
    trailerName: '',
    trailerTypeName: '',
    trailerRegion: '',
    trailerStatus: '',
    subcarrierName: '',
    createdTimestamp: '',
    archivedTimestamp: '',
  };
  public searchQuery = '';
  public selectedCategory = 'trailerName';

  constructor() {}

  ngOnInit(): void {
    this.trailers.subscribe((trailers) => {
      this.sortedArchivedTrailers = trailers;
    });
  }

  sortTrailers(key: string) {
    if (this.sortKey === key) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortKey = key;
      this.sortOrder = 'asc';
    }

    // Reset all icons
    for (const k in this.sortIcons) {
      if (this.sortIcons.hasOwnProperty(k)) {
        this.sortIcons[k] = '';
      }
    }

    // Set the current sort icon
    this.sortIcons[key] = this.sortOrder === 'asc' ? '▲' : '▼';

    this.sortedArchivedTrailers.sort((a, b) => {
      const aValue = a[key] ?? '';
      const bValue = b[key] ?? '';
      const comparison = aValue.localeCompare(bValue);
      return this.sortOrder === 'asc' ? comparison : -comparison;
    });
  }

  public closeNewTrailerForm() {
    this.createEdit$$.next(null);
  }

  prettyStatus(s: string): string {
    switch (s.toLowerCase()) {
      case 'out_of_service':
        return 'Out of Service';
      case 'available':
        return 'Available';
      case 'rented':
        return 'Rented';
      case 'maintenance':
        return 'Maintenance';
      default:
        return s;
    }
  }

  filterTrailers() {
    const query = this.searchQuery.toLowerCase();
    this.trailers.subscribe((trailers) => {
      if (!trailers) {
        this.sortedArchivedTrailers = [];
        return;
      }

      if (!query) {
        this.sortedArchivedTrailers = trailers;
      } else {
        this.sortedArchivedTrailers = trailers.filter((trailer) => {
          const fieldValue = trailer[this.selectedCategory]?.toLowerCase() ?? '';
          return fieldValue.includes(query);
        });
      }
    });
  }

  clearSearch() {
    this.searchQuery = '';
    this.filterTrailers();
  }
}
